import $ from 'jquery';

export function initMainDashboard() {
    const config = window.dashboardConfig;
    if (!config) return;

    // --- 1. CRITICAL PENYULANG ALERT ---
    if (config.criticalPenyulang && config.criticalPenyulang.length > 0) {
        if (typeof Swal !== 'undefined') {
            let currentPage = 1;
            const itemsPerPage = 5;

            function renderAlertPage(page) {
                let html = '<div class="text-start"><p class="text-body-secondary small mb-3">Penyulang berikut sering mengalami gangguan (trip) pada periode ini namun belum ada laporan inspeksi, eksekusi, patroli, maupun ROW:</p><ul class="text-start mb-0 list-unstyled" style="font-size: 0.9rem; min-height: 250px;">';
                
                const start = (page - 1) * itemsPerPage;
                const end = start + itemsPerPage;
                const paginatedItems = config.criticalPenyulang.slice(start, end);
                
                paginatedItems.forEach(cp => {
                    html += `
                    <li class="mb-3 text-body-emphasis" style="border-bottom: 1px dashed #dee2e6; padding-bottom: 8px;">
                        <div class="fw-bold">${cp.nama_penyulang} <span class="badge bg-danger ms-2 shadow-sm">${cp.trip_count} kali trip</span></div>
                        <div class="text-body-secondary" style="font-size: 0.75rem;"><i class="bi bi-geo-alt me-1 text-danger"></i>${cp.nama_up3} - ${cp.nama_ulp}</div>
                    </li>`;
                });
                
                html += '</ul>';
                
                const totalPages = Math.ceil(config.criticalPenyulang.length / itemsPerPage);
                if (totalPages > 1) {
                    html += '<div class="d-flex justify-content-between align-items-center mt-2">';
                    html += `<button class="btn btn-sm btn-outline-primary px-3" onclick="window.changeAlertPageDash(${page - 1})" ${page === 1 ? 'disabled' : ''}><i class="bi bi-chevron-left"></i> Prev</button>`;
                    html += `<span class="small text-body-secondary fw-bold">Hal ${page} / ${totalPages}</span>`;
                    html += `<button class="btn btn-sm btn-outline-primary px-3" onclick="window.changeAlertPageDash(${page + 1})" ${page === totalPages ? 'disabled' : ''}>Next <i class="bi bi-chevron-right"></i></button>`;
                    html += '</div>';
                }
                html += '</div>';
                return html;
            }

            window.changeAlertPageDash = function(newPage) {
                currentPage = newPage;
                Swal.update({ html: renderAlertPage(currentPage) });
            };

            setTimeout(() => {
                Swal.fire({
                    title: 'Perhatian! Penyulang Kritis',
                    icon: 'warning',
                    html: renderAlertPage(1),
                    confirmButtonText: '<i class="bi bi-x-circle me-1"></i> Tutup',
                    confirmButtonColor: '#4f46e5',
                    allowOutsideClick: true,
                    width: '600px'
                });
            }, 500);
        }
    }

    // --- 2. APEXCHARTS INITIALIZATION ---
    if (typeof window.ApexCharts !== 'undefined') {
        const rawTrendData = config.trendEksekusi || [];
        const monthNames = config.months || {};

        function getTrendData(filterType, filterYear) {
            let categories = [];
            let dataSelesai = [];
            let dataProgress = [];
            let dataKendala = [];

            if (filterType === 'all') {
                const d = new Date();
                for (let i = 11; i >= 0; i--) {
                    const pastDate = new Date(d.getFullYear(), d.getMonth() - i, 1);
                    const m = pastDate.getMonth() + 1;
                    const y = pastDate.getFullYear();
                    
                    const mKey = m.toString().padStart(2, '0');
                    categories.push((monthNames[mKey] || mKey) + " " + y.toString().slice(2));
                    
                    const found = rawTrendData.find(item => item.tahun == y && item.bulan == m);
                    dataSelesai.push(found ? parseInt(found.selesai) : 0);
                    dataProgress.push(found ? parseInt(found.progress) : 0);
                    dataKendala.push(found ? parseInt(found.kendala) : 0);
                }
            } else {
                const startMonth = filterType === '1' ? 1 : 7;
                const endMonth = filterType === '1' ? 6 : 12;
                
                for (let m = startMonth; m <= endMonth; m++) {
                    const mKey = m.toString().padStart(2, '0');
                    categories.push(monthNames[mKey] || mKey);
                    
                    const found = rawTrendData.find(item => item.tahun == filterYear && item.bulan == m);
                    dataSelesai.push(found ? parseInt(found.selesai) : 0);
                    dataProgress.push(found ? parseInt(found.progress) : 0);
                    dataKendala.push(found ? parseInt(found.kendala) : 0);
                }
            }
            return { categories, dataSelesai, dataProgress, dataKendala };
        }
        
        function getThemeMode() {
            return document.documentElement.getAttribute('data-bs-theme') === 'dark' ? 'dark' : 'light';
        }

        let initialTrend = getTrendData('all', config.currentYear);
        var trendOptions = {
            series: [
                { name: 'Selesai', data: initialTrend.dataSelesai }, 
                { name: 'Progress', data: initialTrend.dataProgress }, 
                { name: 'Kendala', data: initialTrend.dataKendala }
            ],
            chart: { type: 'line', height: 250, toolbar: { show: false }, parentHeightOffset: 0 },
            theme: { mode: getThemeMode() },
            colors: ['#10b981', '#3b82f6', '#f59e0b'],
            stroke: { width: 3, curve: 'smooth' },
            markers: { size: 4 },
            xaxis: {
                categories: initialTrend.categories,
                labels: { style: { fontSize: '11px' } },
                axisBorder: { show: false }, axisTicks: { show: false }
            },
            yaxis: {
                labels: { style: { fontSize: '11px' } },
                min: 0
            },
            grid: { strokeDashArray: 4, padding: { top: 0, right: 0, bottom: 0, left: 10 } },
            legend: { position: 'top', horizontalAlign: 'left', offsetX: -10, markers: { radius: 12 } },
            tooltip: { theme: getThemeMode() }
        };

        const trendEl = document.querySelector("#trendChart");
        var trendChart = null;
        if (trendEl) {
            trendChart = new window.ApexCharts(trendEl, trendOptions);
            trendChart.render();
        }
        
        const trendSemesterFilter = document.getElementById('trendSemesterFilter');
        const trendYearFilter = document.getElementById('trendYearFilter');
        
        if (trendSemesterFilter) {
            trendSemesterFilter.addEventListener('change', function() {
                let val = this.value;
                if(val === 'all') {
                    trendYearFilter.style.display = 'none';
                } else {
                    trendYearFilter.style.display = 'block';
                }
                updateTrendChart();
            });
        }
        
        if (trendYearFilter) {
            trendYearFilter.addEventListener('change', function() {
                updateTrendChart();
            });
        }
        
        function updateTrendChart() {
            if(!trendChart) return;
            let filterType = trendSemesterFilter ? trendSemesterFilter.value : 'all';
            let filterYear = trendYearFilter ? trendYearFilter.value : config.currentYear;
            let newData = getTrendData(filterType, filterYear);
            
            trendChart.updateOptions({
                xaxis: { categories: newData.categories }
            });
            trendChart.updateSeries([
                { name: 'Selesai', data: newData.dataSelesai }, 
                { name: 'Progress', data: newData.dataProgress }, 
                { name: 'Kendala', data: newData.dataKendala }
            ]);
        }

        // Donut Chart
        var donutOptions = {
            series: [config.stats.selesai, config.stats.progress, config.stats.kendala, config.stats.belum, config.stats.waiting],
            chart: { type: 'donut', height: 250, width: '100%' },
            theme: { mode: getThemeMode() },
            labels: ['Selesai', 'Progress', 'Kendala', 'Belum Dieksekusi', 'Waiting'],
            colors: ['#10b981', '#3b82f6', '#f59e0b', '#ef4444', '#8b5cf6'],
            plotOptions: {
                pie: { donut: { size: '70%', labels: { show: true, total: { show: true, showAlways: true, label: 'Total', fontSize: '14px', fontWeight: 'bold' } } } }
            },
            dataLabels: { enabled: false },
            stroke: { width: 2, colors: ['#fff'] },
            legend: { position: 'bottom', fontSize: '11px', markers: { radius: 12 } },
            tooltip: { theme: getThemeMode() }
        };
        const donutEl = document.querySelector("#donutChart");
        var donutChart = null;
        if(donutEl) {
            donutChart = new window.ApexCharts(donutEl, donutOptions);
            donutChart.render();
        }

        // Bar Chart
        var barOptions = {
            series: [{
                name: 'Total',
                data: [config.stats.total_inspeksi, config.stats.total_patrol, config.stats.total_row, config.stats.total_gangguan, config.stats.pohon_bahaya, config.stats.work_order]
            }],
            chart: { type: 'bar', height: 250, toolbar: { show: false }, parentHeightOffset: 0 },
            theme: { mode: getThemeMode() },
            colors: ['#3b82f6', '#0ea5e9', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'],
            plotOptions: {
                bar: { borderRadius: 4, columnWidth: '40%', distributed: true, dataLabels: { position: 'top' } }
            },
            dataLabels: { enabled: true, formatter: function(val) { return val; }, offsetY: -20, style: { fontSize: '10px', colors: ["var(--bs-body-color)"] } },
            legend: { show: false },
            xaxis: {
                categories: ['Inspeksi', 'Patrol', 'ROW', 'Gangguan', 'Pohon', 'WO'],
                labels: { style: { fontSize: '11px' } },
                axisBorder: { show: false }, axisTicks: { show: false }
            },
            yaxis: { labels: { formatter: function(val) { return val >= 1000 ? (val/1000).toFixed(1) + 'k' : val; }, style: { fontSize: '11px' } } },
            grid: { strokeDashArray: 4, padding: { top: 15, right: 0, bottom: 0, left: 10 } },
            tooltip: { theme: getThemeMode() }
        };
        const barEl = document.querySelector("#barChart");
        var barChart = null;
        if(barEl) {
            barChart = new window.ApexCharts(barEl, barOptions);
            barChart.render();
        }

        // Dynamic Theme Update Observer
        const observerTheme = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-bs-theme') {
                    const newTheme = getThemeMode();
                    if (trendChart) trendChart.updateOptions({ theme: { mode: newTheme }, tooltip: { theme: newTheme } });
                    if (donutChart) donutChart.updateOptions({ theme: { mode: newTheme }, tooltip: { theme: newTheme } });
                    if (barChart) barChart.updateOptions({ theme: { mode: newTheme }, tooltip: { theme: newTheme } });
                }
            });
        });
        observerTheme.observe(document.documentElement, { attributes: true });
    }

    // --- 3. LEAFLET MAP INITIALIZATION ---
    if (typeof window.L !== 'undefined' && document.getElementById('map-dashboard')) {
        var map = window.L.map('map-dashboard', { zoomControl: false }).setView([0.5422, 122.9510], 9);
        window.L.control.zoom({ position: 'topleft' }).addTo(map);
        
        window.L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; OpenStreetMap &copy; CARTO',
            subdomains: 'abcd',
            maxZoom: 20
        }).addTo(map);

        var dummyPoints = [
            [0.5422, 122.9510, '#10b981', 'UP3 Gorontalo'],
            [0.6186, 122.9818, '#3b82f6', 'ULP Limboto'],
            [0.7245, 122.8687, '#f59e0b', 'ULP Telaga'],
            [0.8529, 122.9097, '#ef4444', 'Kwandang'],
            [0.4578, 121.9322, '#8b5cf6', 'Marisa']
        ];

        dummyPoints.forEach(function(pt) {
            var circleMarker = window.L.circleMarker([pt[0], pt[1]], {
                radius: 8,
                fillColor: pt[2],
                color: '#fff',
                weight: 2,
                opacity: 1,
                fillOpacity: 0.8
            }).addTo(map);
            circleMarker.bindPopup('<b>' + pt[3] + '</b>');
        });
    }

    // --- 4. DATA FILTER AUTO-SUBMIT ---
    const filterForm = document.getElementById('filter-form');
    if (filterForm) {
        const selectMonth = filterForm.querySelector('select[name="month"]');
        const selectYear = filterForm.querySelector('select[name="year"]');
        const selectUp3 = filterForm.querySelector('select[name="id_up3"]');
        const selectUlp = filterForm.querySelector('select[name="id_ulp"]');

        [selectMonth, selectYear, selectUlp].forEach(select => {
            select?.addEventListener('change', () => filterForm.submit());
        });

        selectUp3?.addEventListener('change', () => {
            if (selectUlp) selectUlp.value = '';
            filterForm.submit();
        });
    }

    // --- 5. MODAL DATATABLES FOR STAT CARDS ---
    let tableDataDashboard = null;
    $('.card-stat-eksekusi').on('click', function() {
        const status = $(this).data('status');
        if (!status) return;
        
        const statusNames = {
            'total': 'Semua Data Inspeksi',
            'selesai': 'Data Inspeksi Selesai',
            'proses': 'Data Inspeksi Proses',
            'kendala': 'Data Inspeksi Kendala',
            'belum_eksekusi': 'Data Belum Dieksekusi / WO',
            'waiting': 'Data Inspeksi Waiting'
        };
        
        $('#modalDataDashboardTitle').text(statusNames[status] || 'Data Inspeksi');
        
        const modalEl = document.getElementById('modalDataDashboard');
        if (modalEl) {
            const modal = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
            modal.show();
            
            $(modalEl).off('shown.bs.modal').on('shown.bs.modal', function () {
                if (tableDataDashboard) {
                    setTimeout(() => {
                        tableDataDashboard.columns.adjust().draw('page');
                    }, 200);
                }
            });
        }
        
        let filterStatus = '';
        if (status === 'selesai') filterStatus = 'SELESAI';
        else if (status === 'proses') filterStatus = 'WORK_ORDER';
        else if (status === 'kendala') filterStatus = 'KENDALA';
        else if (status === 'belum_eksekusi') filterStatus = 'TEMUAN';
        else if (status === 'waiting') filterStatus = 'WAITING_APPROVAL';

        const filters = {
            status_inspeksi: filterStatus ? [filterStatus] : []
        };
        
        const month = $('select[name="month"]').val();
        const year = $('select[name="year"]').val();
        const id_up3 = $('select[name="id_up3"]').val();
        const id_ulp = $('select[name="id_ulp"]').val();
        
        if (month && month !== 'all' && year && year !== 'all') {
            const lastDay = new Date(year, month, 0).getDate();
            filters.start_date = `${year}-${month.padStart(2, '0')}-01`;
            filters.end_date = `${year}-${month.padStart(2, '0')}-${lastDay}`;
        } else if (year && year !== 'all') {
            filters.start_date = `${year}-01-01`;
            filters.end_date = `${year}-12-31`;
        }
        
        if (id_up3) filters.id_up3 = id_up3;
        if (id_ulp) filters.id_ulp = id_ulp;

        const ajaxUrl = window.location.origin + '/inspeksi-jtm/ajax-list';
        
        if (tableDataDashboard) {
            tableDataDashboard.context[0].ajax.data = function (d) {
                const csrfTokenName = document.querySelector('meta[name="X-CSRF-TOKEN-NAME"]')?.getAttribute('content') || 'csrf_test_name';
                const csrfHash = document.querySelector('meta[name="X-CSRF-TOKEN"]')?.getAttribute('content') || '';
                d[csrfTokenName] = csrfHash;
                return $.extend({}, d, filters);
            };
            tableDataDashboard.ajax.reload();
        } else {
            tableDataDashboard = $('#tableDataDashboard').DataTable({
                processing: true,
                serverSide: true,
                ajax: {
                    url: ajaxUrl,
                    type: 'POST',
                    data: function(d) {
                        const csrfTokenName = document.querySelector('meta[name="X-CSRF-TOKEN-NAME"]')?.getAttribute('content') || 'csrf_test_name';
                        const csrfHash = document.querySelector('meta[name="X-CSRF-TOKEN"]')?.getAttribute('content') || '';
                        d[csrfTokenName] = csrfHash;
                        return $.extend({}, d, filters);
                    }
                },
                columns: [
                    { data: 'no', orderable: false, searchable: false },
                    { data: 'kode_inspeksi' },
                    { data: 'nomor_tiang' },
                    { data: 'tanggal' },
                    { data: 'nama_komponen' },
                    { data: 'skala_prioritas' },
                    { data: 'status_inspeksi' }
                ],
                order: [[3, 'desc']],
                language: {
                    search: 'Cari:', lengthMenu: '_MENU_',
                    info: "<span class='text-muted fw-medium'>Menampilkan <b class='text-dark'>_START_-_END_</b> dari <b class='text-dark'>_TOTAL_</b></span>",
                    infoEmpty: "<span class='text-muted'>Menampilkan 0 data</span>",
                    infoFiltered: "<span class='text-muted'>(disaring dari _MAX_ data)</span>",
                    emptyTable: "<div class='text-center py-4 text-muted'><i class='bi bi-inbox fs-4 d-block mb-2'></i>Belum ada Data Inspeksi</div>",
                    zeroRecords: "<div class='text-center py-4 text-muted'><i class='bi bi-search fs-4 d-block mb-2'></i>Pencarian tidak ditemukan</div>",
                    paginate: { previous: 'Sebelumnya', next: 'Berikutnya' },
                    processing: '<div class="dt-loader-container"><div class="dt-loader-spinner"><div class="spinner-border text-primary" role="status"></div></div><div class="dt-loader-text">Memuat Data...</div></div>'
                }
            });
        }
    });
}
